import React from "react";
import { ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export default function Guarantee() {
  return (
    <section className="relative bg-white py-20 md:py-28" data-testid="guarantee-section">
      <div className="mx-auto max-w-4xl px-6 lg:px-8">
        <Reveal>
          <div className="flex flex-col items-center gap-8 rounded-3xl border border-ocean-mid/15 bg-ocean-light/50 p-8 text-center sm:flex-row sm:p-12 sm:text-left">
            <div className="relative shrink-0">
              <div className="flex h-32 w-32 animate-float-slow flex-col items-center justify-center rounded-full cta-sun text-white shadow-xl shadow-sun/30">
                <ShieldCheck className="h-9 w-9" />
                <span className="mt-1 font-display text-2xl font-extrabold leading-none">30</span>
                <span className="text-[0.6rem] font-bold uppercase tracking-widest">dias</span>
              </div>
            </div>
            <div>
              <h2 className="font-display text-3xl font-extrabold uppercase text-brand-navy sm:text-4xl">
                Garantia total de 30 dias
              </h2>
              <p className="mt-3 text-base leading-relaxed text-brand-navy/75">
                Se mudar de ideia, devolvemos 100% do seu dinheiro. Sem burocracia,
                sem perguntas difíceis. O risco é todo nosso — a aventura é toda sua.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
